// extracted by mini-css-extract-plugin
export default {"practice-area-select":"Vunq5","tab-content":"yf5sA","search-filter":"ZDDQt","template-list":"f469M","pagination-container":"Zj1KT"};